import {
  AsyncStatusIndicator,
  MBox,
  MCustomNumberInput,
  MFlex,
  MFormControl,
  MFormLabel,
  MSwitch,
  MText,
  RadioStyleButtonGroup,
} from '../../../../../components/Monetize';
import type { AsyncStatus } from '@monetize/types/common';
import { FREQUENCY_ITEMS } from '../../../../../constants/quotes';
import { getShortCodeForUnitPriceFrequency } from '../../../../../utils/quotes';

interface DisplayUnitPriceFrequencyProps {
  isLoading?: boolean;
  asyncStatus?: AsyncStatus;
  value?: null | number;
  onChange: (value: null | number) => void | Promise<void>;
}

const displayFrequencyOptions = FREQUENCY_ITEMS.map(({ value }) => ({
  label: value,
  value: `${value}`,
}));
export const DisplayUnitPriceFrequency = ({
  isLoading = false,
  asyncStatus = 'idle',
  value,
  onChange,
}: DisplayUnitPriceFrequencyProps) => {
  return (
    <MBox>
      <MFormControl orientation="horizontal" width="full" gap="4" mb="2">
        <MFormLabel
          htmlFor={'default-display-frequency'}
          fontSize="md"
          fontWeight="600"
          mb="0"
          flex="1"
        >
          Override Prices Display on Quotes
        </MFormLabel>
        <MBox position="relative">
          <MSwitch
            isDisabled={isLoading || asyncStatus === 'loading'}
            isChecked={!!value}
            id={'default-display-frequency'}
            aria-describedby={`default-display-frequency-subheading`}
            onChange={({ target }) => onChange(target.checked ? 1 : null)}
          />
          <AsyncStatusIndicator status={asyncStatus} />
        </MBox>
      </MFormControl>

      <MFlex direction="column" gap={2}>
        <MText id="default-display-frequency-subheading">
          Set a default Display Frequency (i.e. monthly, annually, etc) for all
          products on Quote PDFs. This does not impact invoicing.
        </MText>

        <MFlex align="center">
          <MText mr="2">Per</MText>
          <MCustomNumberInput
            onChange={(_valueAsString: string, valueAsNumber: number) =>
              onChange(valueAsNumber)
            }
            value={value || ''}
            min={1}
            max={60}
            maxW="50px"
            isDisabled={!value}
            mr="2"
          />
          <MText>Month(s)</MText>
        </MFlex>
        <MBox maxW="300px">
          <RadioStyleButtonGroup
            name="displayUnitPriceFrequencyOptions"
            options={displayFrequencyOptions}
            value={`${value || ''}` || undefined}
            defaultValue={`${value || ''}` || undefined}
            onChange={(selectedValue: string) => {
              onChange(+selectedValue);
            }}
            isDisabled={!value}
          />
        </MBox>
        {!!value && (
          <MText mt="2">
            How it will appear on Quote: $5.00/
            {getShortCodeForUnitPriceFrequency(value)}
          </MText>
        )}
      </MFlex>
    </MBox>
  );
};
